module.exports = __webpack_public_path__ + "assets/img/37_1030_big.94318d99.jpg";